/* eslint-disable no-negated-condition */

'use strict'
import d3 from 'd3'
import {bootstrap} from '../bootstrap/bootstrap'
import {getCampaignsByIndustry} from './networking'
import {attachFilterEvents} from './handlers'
import {AttributionChart} from './chart'

const attribution = document.querySelector('.attribution')
const campaignsPerIndustry = {}
let attributionChart
let attributionElements

bootstrap(attribution, attribution => {
  attributionChart = new AttributionChart(d3, '.attribution .graph')
  attributionElements = {
    campaignDropdown: attribution.querySelector(`select[data-name="campaign"]`),
    campaignDropdownUI: attribution.querySelector(`.dropdown__ui[data-name="campaign"]`),
    industryDropdown: attribution.querySelector(`select[data-name="industry"]`),
    downloadButton: attribution.querySelector('.download.button'),
    incrementalVisitLift: attribution.querySelector('.stat[data-stat="incremental-visit-lift"] h1'),
    adType: attribution.querySelector('.stat[data-stat="ad-type"] h1'),
    device: attribution.querySelector('.stat[data-stat="device"] h1'),
    duration: attribution.querySelector('.stat[data-stat="duration"] h1'),
    quarter: attribution.querySelector('.stat[data-stat="quarter"] h1'),
    cost: attribution.querySelector('.stat[data-stat="cost"] h1'),
    impressions: attribution.querySelector('.stat[data-stat="impressions"] h1')
  }
})

bootstrap(attribution, attribution => {
  const filterDropdowns = Array.from(attribution.querySelectorAll('select[data-type="filter"]'))
  attachFilterEvents(filterDropdowns)

  attributionElements.industryDropdown.addEventListener('change', () => {
    const industryName = attributionElements.industryDropdown.options[attributionElements.industryDropdown.options.selectedIndex].value
    if (campaignsPerIndustry[industryName] === undefined) {
      return getCampaignsByIndustry(industryName).then(data => {
        campaignsPerIndustry[industryName] = data.results
        updateCampaigns(data.results)
      })
    }
    updateCampaigns(campaignsPerIndustry[industryName])
  })

  attributionElements.campaignDropdown.addEventListener('change', () => {
    const campaignName = attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value
    const industryName = attributionElements.industryDropdown[attributionElements.industryDropdown.selectedIndex].value
    getCampaignObject(campaignName, industryName, campaignObject => {
      updateCampaignData(campaignObject)
    })
  })

  // render first chart on load
  const industryName = attributionElements.industryDropdown[attributionElements.industryDropdown.selectedIndex].value
  const campaignName = attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value
  getCampaignObject(campaignName, industryName, campaignObject => {
    updateCampaignData(campaignObject)
  })
})

async function getCampaignObject(campaignName, industryName, cb) {
  if (campaignsPerIndustry[industryName] === undefined) {
    const data = await getCampaignsByIndustry(industryName)
    campaignsPerIndustry[industryName] = data.results
  }
  const campaignObject = campaignsPerIndustry[industryName].find(campaignObject => campaignObject.name === campaignName)
  cb(campaignObject)
}

function updateCampaigns(campaigns) {
  const campaignDropdownItems = Array.from(attributionElements.campaignDropdown.querySelectorAll('option'))

  campaignDropdownItems.forEach(selectOption => selectOption.remove())

  campaigns.forEach(campaign => {
    const option = document.createElement('option')
    option.value = campaign.name
    option.innerHTML = campaign.name
    attributionElements.campaignDropdown.appendChild(option)
  })

  attributionElements.campaignDropdownUI.innerHTML = attributionElements.campaignDropdown.options.length > 0 ? `<span>${attributionElements.campaignDropdown.options[attributionElements.campaignDropdown.options.selectedIndex].value}</span> ⌵` : ''

  const currentCampaign = campaigns[0]
  updateCampaignData(currentCampaign)
}

function updateCampaignData(campaign) {
  if (!campaign) {
    console.error(new Error(`campaign is not valid!, ${campaign}`))
  }

  attributionChart.renderChart(campaign)

  attributionElements.incrementalVisitLift.innerText = `${campaign.incremental_visit_lift}%`
  attributionElements.adType.innerText = `${campaign.ad_type}`
  attributionElements.device.innerText = `${campaign.device}`
  attributionElements.duration.innerText = `${campaign.duration} Days`
  attributionElements.quarter.innerText = `${campaign.quarter}`
  attributionElements.cost.innerText = `$${campaign.cost}K`
  attributionElements.impressions.innerText = `${campaign.impressions}MM`

  if (campaign.pdf === null) {
    attributionElements.downloadButton.style.display = 'none'
    return
  }

  attributionElements.downloadButton.setAttribute('href', campaign.pdf)
  attributionElements.downloadButton.style.display = 'inline-block'
}
